import gsap, { Linear } from 'gsap';
import Environment from '../environment';

const duration = Environment.isVMS1100() ? 0 : 0.5;

gsap.registerEffect({
	name: 'fadeIn',
	effect: (targets, config) => gsap.to(targets, config),
	defaults: {
		duration,
		autoAlpha: 1,
		ease: Linear.easeNone,
	},
	extendTimeline: true,
});

gsap.registerEffect({
	name: 'fadeOut',
	effect: (targets, config) => gsap.to(targets, config),
	defaults: {
		duration,
		autoAlpha: 0,
		ease: Linear.easeNone,
	},
	extendTimeline: true,
});

export default gsap;
